import { BusinessObjectPart, BusinessObjectPartContext, CollectionChangedContext, ModelBase, ObservableCollection, PropertyChangingJoinPoint, Weaver } from '@skylab-shared/core';
import { DocumentItemModel } from '@skylab-shared/dataModel';
import { propertyChangedFilter } from '../../common/property-changed/property-changed-filter';
import { collectionChangedFilter } from '../../utils/collection-changed-filter';
import { propertyChangingJoinPointFilter } from '../../utils/property-changing-filter';

interface DocumentModelPart extends ModelBase {
    items: ObservableCollection<DocumentItemModel>;
}

export class DocumentItemsNumberingBoPart extends BusinessObjectPart<DocumentModelPart> {
    public constructor(
        weaver: Weaver,
    ) {
        super(weaver);
    }

    public override async initializeAsync(context: BusinessObjectPartContext<DocumentModelPart>): Promise<void> {
        await super.initializeAsync(context);
        this.registerNumberingsFeatures();
    }

    private registerNumberingsFeatures(): void {
        let numbering = false;
        const numberItems = () =>  {
            try {
                numbering = true;
                this.numberDocumentItems();
            } finally {
                numbering = false;
            }
        };
        
        this.coreFeature.collectionChanged.listen<DocumentModelPart>(ctx => onItemsCollectionChanged(ctx as unknown as CollectionChangedContext<DocumentModelPart>));
        const onItemsCollectionChanged = collectionChangedFilter(
            this.modelType,
            'items',
            () => numberItems()
        )

        this.coreFeature.propertyChanged.listen<DocumentModelPart>(propertyChangedFilter(
            this.modelType,
            ['items'],
            () => numberItems()
        ));

        this.registerListening(this.weaver.register(PropertyChangingJoinPoint, propertyChangingJoinPointFilter(this.bo)(DocumentItemModel, ['ordinalNumber'])(
            ctx => !numbering && ctx.cancel()
        )));
    }

    private numberDocumentItems(): void {
        this.bo.model.items.forEach((item, index) => item.ordinalNumber = index + 1);
    }
}
